import { Grid } from "@material-ui/core";
import { debounce } from "lodash";
import { memo, useCallback, useState } from "react";
import { LuSparkles } from "react-icons/lu";
import { useHistory } from "react-router-dom";
import errorIcon from '../../assets/images/info-circle-line-icon.svg';
import { handleKeyDown } from "../../common/common";
import CustomTooltip from "../../common/Tooltip";
import {
  fuelPriceOptions,
  initialVesselState,
  scrubberOptions,
  vesselCalculatorMainFields,
} from "../../constants";
import { addFleet, portsByChar } from "../../containers/User/Calculator/actions";
import { toastError, toastSuccess } from "../../utils";
import CustomAddModal from "../Common/CustomAddModal";
import AddNewVessel from "../Dashboard/AddNewVessel";

function CalculatorVesselDetails(props) {
  const history = useHistory();
  const {
    setLoader = () => { },
    selectedVessels = {},
    setSelectedVessels = () => { },
    calculatorData = {},
    setCalculatorData = () => { },
    onChangeHandler = () => { },
    disableEdit = false,
    onClickEditVesselContract,
    isContractEstimate = false,
  } = props || {};

  const [newVessel, setNewVessel] = useState({ ...initialVesselState });
  const [aiOpen, setAiOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [portLoading, setPortLoading] = useState(false);
  const [savePortList, setSavePortList] = useState([]);
  const vessel =
    (selectedVessels &&
      selectedVessels.vessel &&
      JSON.parse(selectedVessels.vessel)) ||
    {};

  const {
    vesselBalConsmHS1 = 0,
    vesselBalConsmHS2 = 0,
    vesselBalConsmHS3 = 0,
    vesselBalConsmHS4 = 0,
    vesselBalConsmLS1 = 0,
    vesselBalConsmLS2 = 0,
    vesselBalConsmLS3 = 0,
    vesselBalConsmLS4 = 0,
    vesselBalConsmMGO1 = 0,
    vesselBalConsmMGO2 = 0,
    vesselBalConsmMGO3 = 0,
    vesselBalConsmMGO4 = 0,
    vesselBalSpd1 = 0,
    vesselBalSpd2 = 0,
    vesselBalSpd3 = 0,
    vesselBalSpd4 = 0,
    vesselDwt = 0,
    vesselName = "",
    vesselGrainCap = 0,
    vesselDraftS = 0,
    vesselLdnConsmHS1 = 0,
    vesselLdnConsmHS2 = 0,
    vesselLdnConsmHS3 = 0,
    vesselLdnConsmHS4 = 0,
    vesselLdnConsmLS1 = 0,
    vesselLdnConsmLS2 = 0,
    vesselLdnConsmLS3 = 0,
    vesselLdnConsmLS4 = 0,
    vesselLdnConsmMGO1 = 0,
    vesselLdnConsmMGO2 = 0,
    vesselLdnConsmMGO3 = 0,
    vesselLdnConsmMGO4 = 0,
    vesselLdnSpd1 = 0,
    vesselLdnSpd2 = 0,
    vesselLdnSpd3 = 0,
    vesselLdnSpd4 = 0,
    vesselPDischConsmHS = 0,
    vesselPDischConsmLS = 0,
    vesselPDischConsmMGO = 0,
    vesselPIdleConsmHS = 0,
    vesselPIdleConsmLS = 0,
    vesselPIdleConsmMGO = 0,
    vesselPLdgConsmHS = 0,
    vesselPLdgConsmLS = 0,
    vesselPLdgConsmMGO = 0,
    vesselVExtraConsmHS = 0,
    vesselVExtraConsmLS = 0,
    vesselVExtraConsmMGO = 0,
    vesselIMO = "",
    fuelType = "",
    vesselBalComb1Selected,
    vesselBalComb2Selected,
    vesselBalComb3Selected,
    vesselBalComb4Selected,
    vesselLadComb1Selected,
    vesselLadComb2Selected,
    vesselLadComb3Selected,
    vesselLadComb4Selected,
    vesselScrubber,
  } = vessel || {};

  const { clientQuery = {} } = calculatorData || {};

  const onChangeVesselScrubber = (e) => {
    const { name = "", value = "" } = e.target;
    let newVessel = { ...vessel };
    newVessel[name] = value;
    const updatedFleet = {
      ...selectedVessels,
      vessel: JSON.stringify(newVessel),
    };
    setSelectedVessels(updatedFleet);
    let updatedCalculatorData = { ...calculatorData };

    let newCargoDetails = {};
    if (name === "fuelType") {
      const currentType = value.replace("TYPE", "");
      newCargoDetails[`fuelPriceType${currentType}Hsfo`] = Number(
        clientQuery[`hsFuelPriceType${currentType}`]
      );
      newCargoDetails[`fuelPriceType${currentType}Lsfo`] = Number(
        clientQuery[`lsFuelPriceType${currentType}`]
      );
      newCargoDetails[`fuelPriceType${currentType}Mgo`] = Number(
        clientQuery[`mgoFuelPriceType${currentType}`]
      );
    }

    updatedCalculatorData = {
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        ...newCargoDetails,
        [name]: value,
      },
      fleetList: updatedCalculatorData.fleetList.map((item) => {
        if (item._id === updatedFleet._id) {
          return updatedFleet;
        }
        return item;
      }),
    };
    setCalculatorData(updatedCalculatorData);
  };

  // const onChangeFleetCheckBox = (type, e) => {
  //     const { name = '', checked = '' } = e.target || {}

  //     setFleetCheckbox({
  //         ...fleetCheckbox, [type]: {
  //             ...fleetCheckbox[type],
  //             [name]: checked
  //         }
  //     })
  // }

  const onSubmitConfirm = () => {
    if (!newVessel.vesselName) return toastError("Vessel Name is required");

    setLoader(true);

    //
    const excludedFieldKeys = [
      "port",
      "lat",
      "lng",
      "bnkDelhs",
      "bnkDells",
      "bnkDelmgo",
      "bnkPriceDeliveryhs",
      "bnkPriceDeliveryls",
      "bnkPriceDeliverymgo",
      "bnkPriceRedeliveryhs",
      "bnkPriceRedeliveryls",
      "bnkPriceRedeliverymgo",
      "bnkPriceSettlemenths",
      "bnkPriceSettlementls",
      "bnkPriceSettlementmgo",
      "bnkQtyRedeliveryhs",
      "bnkQtyRedeliveryls",
      "bnkQtyRedeliverymgo",
      "bnkRedeliveryQtyTolerancehs",
      "bnkRedeliveryQtyTolerancels",
      "bnkRedeliveryQtyTolerancemgo",
      "bunkerPriceOverridden",
      "dateOpen",
      "gbb",
      "hirePerDay",
      "hireGbb",
      "remark",
      "constants",
      "extraExpense",
      "splitHire",
    ];


    const excludedFields = Object.fromEntries(
      excludedFieldKeys.map((key) => [key, newVessel[key]])
    );


    const { ...otherFields } = newVessel;


    const cleanedFields = Object.fromEntries(
      Object.entries(otherFields).filter(([key]) => !excludedFieldKeys.includes(key))
    );


    const vesselString = JSON.stringify(cleanedFields);

    const finalVesselData = {
      vesselName: newVessel.vesselName,
      dwt: newVessel.vesselDwt,
      dateOpen: newVessel.dateOpen,
      ...excludedFields,
      vessel: vesselString,
      superAdminApproval: "pending",
      port: newVessel.selectedPort?.portLabel || "",
      dateOpen: newVessel.dateOpen,
    };


    addFleet(finalVesselData)
      .then((res) => {
        onCloseModal();
        setLoader(false);
        toastSuccess("Vessel Created Successfully");
        setNewVessel({ ...initialVesselState });
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message);
        setOpen(true);
      });
  };


  const onChangeHandlerForNew = (e) => {

    let name = "";
    let value = "";
    let type = "text";
    let checked = false;


    if (e._isAMomentObject) {
      name = "dateOpen";
      value = e.toISOString();
    } else if (e.target) {

      ({ name = "", value = "", type = "checkbox", checked } = e.target);
    }

    let updatedVessel = { ...newVessel };

    if (type === "checkbox") {
      updatedVessel[name] = checked;
    } else {
      if (value && value.toString().split("")[0] === 0) return;
      updatedVessel[name] = value;
    }

    setNewVessel(updatedVessel);
  };

  const onCloseModal = () => {
    setOpen(false);
    setNewVessel({ ...initialVesselState });
  };
  const checkBallastError = (vesselBal1, vesselBal2, vesselBal3, vesselBal4) => {
    let vesselBalCheck = []
    if (vesselBalComb1Selected) {
      vesselBalCheck.push(Number(vesselBal1) ? true : false)
    }
    if (vesselBalComb2Selected) {
      vesselBalCheck.push(Number(vesselBal2) ? true : false)
    }
    if (vesselBalComb3Selected) {
      vesselBalCheck.push(Number(vesselBal3) ? true : false)
    }
    if (vesselBalComb4Selected) {
      vesselBalCheck.push(Number(vesselBal4) ? true : false)
    }
    if (vesselBalCheck.every(value => value === false)) {
      return true
    }
  }
  const checkLadenError = (vesselLdn1, vesselLdn2, vesselLdn3, vesselLdn4) => {
    let vesselLdnSpdCheck = []
    if (vesselLadComb1Selected) {
      vesselLdnSpdCheck.push(Number(vesselLdn1) ? true : false)
    }
    if (vesselLadComb2Selected) {
      vesselLdnSpdCheck.push(Number(vesselLdn2) ? true : false)
    }
    if (vesselLadComb3Selected) {
      vesselLdnSpdCheck.push(Number(vesselLdn3) ? true : false)
    }
    if (vesselLadComb4Selected) {
      vesselLdnSpdCheck.push(Number(vesselLdn4) ? true : false)
    }
    if (vesselLdnSpdCheck.every(value => value === false)) {
      return true
    }
  }

  const addNewSplitHire = () => {
    let splitHire =
      (newVessel && newVessel.splitHire && JSON.parse(newVessel.splitHire)) || [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    setNewVessel({
      ...newVessel,
      splitHire: JSON.stringify(splitHire),
    });
  };
  const onChangeBunkerPriceOverridden = (e) => {
    let { name = "", checked = "" } = e.target || {};
    let newUpdatedFleet = { ...newVessel };
    newUpdatedFleet[name] = checked;
    setNewVessel(newUpdatedFleet);
  };

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (newVessel && newVessel.splitHire && JSON.parse(newVessel.splitHire)) || [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedvessel = {
      ...newVessel,
      splitHire: JSON.stringify(splitHire),
    };
    setNewVessel(udpatedvessel);
  };

  const delayPortSearch = useCallback(
    debounce((search) => onSearchPortList(search), 500),
    []
  );

  const onSearchPortList = (value) => {
    if (value) {
      setPortLoading(true);
      portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setSavePortList(
            Array.isArray(res.data.list)
              ? res.data.list.map((item) => ({
                ...item,
                portLabel: `${item.name}${item.country ? ` (${item.country})` : ''}`
              }))
              : []
          );
        })
        .catch((err) => {
          setPortLoading(false);
        });
    }
  };

  const onChangePort = (name, value) => {
    setNewVessel(prevVessel => ({
      ...prevVessel,
      port: value.name,
      selectedPort: value,
      lat: value.lat || "",
      lng: value.lng || ""
    }));
  };
  const disableSelection = (clientQuery?.fuelCalculationMethod || "DEFAULT") !== "DEFAULT";

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <Grid container>
            <Grid item xs={12} className="calculator-section-header vessel-details-header">
              <div className="flex items-center justify-between w-full">
                <h4
                  className="result-heading font-medium text-[12px] m-0"
                  style={{ color: "#ffffff", textDecoration: "none" }}
                >
                  Vessel Details
                </h4>
                {isContractEstimate ? (
                  onClickEditVesselContract && (
                    <span
                      className="text-[10px] cursor-pointer"
                      style={{ color: "#93c5fd", textDecoration: "underline" }}
                      onClick={() => onClickEditVesselContract(true)}
                    >
                      View Contract
                    </span>
                  )
                ) : (
                  <span className="capitalize text-[10px] font-medium" style={{ color: "#ffffff" }}>
                    Please update details for your calculation
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12}>
              <table className="vessel-details-tables w-full block sm:table" style={{ tableLayout: "fixed" }}>
                <tbody className="block sm:table-row-group">
                  <tr className="grid grid-cols-[30%_70%] sm:table-row">
                    <th className="vessel-field-label w-auto sm:w-[13%]">Vessel</th>
                    <td className="w-auto sm:w-[35%]">
                      <input
                        disabled
                        value={vesselName || ""}
                        type="text"
                        name="vesselName"
                        onChange={onChangeHandler}
                      />
                    </td>
                    <th className="w-auto sm:w-[10%]">Dwt</th>
                    <td className="w-auto sm:w-[21%]">
                      <input
                        disabled
                        value={vesselDwt || 0}
                        type="number"
                        name="vesselDwt"
                        onChange={onChangeHandler}
                      />
                    </td>
                    <th className="w-auto sm:w-[8%]">IMO</th>
                    <td className="w-auto sm:w-[13%]">
                      <input
                        disabled
                        value={vesselIMO || ""}
                        type="text"
                        name="vesselIMO"
                        onChange={onChangeHandler}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>

            <Grid item xs={12} sm={4} className="vessel-main-details-column">
              <table className="fleet-result-table">
                <tbody>
                  {vesselCalculatorMainFields.map((item, key) => {
                    if (item.name === "fuelType") {
                      return (
                        <tr key={key}>
                          <th className="text-[11px] font-medium">{item.label}</th>
                          <td>
                            <select
                              value={fuelType || "Type-1"}
                              name="fuelType"
                              className="vessel-scrubber-select"
                              onChange={onChangeVesselScrubber}
                              disabled={disableSelection}
                            >
                              {fuelPriceOptions.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      );
                    }
                    if (item.name === "vesselScrubber") {
                      return (
                        <tr key={key}>
                          <th className="text-[11px] font-medium">{item.label}</th>
                          <td>
                            <select
                              value={vesselScrubber || "Yes"}
                              name="vesselScrubber"
                              className="vessel-scrubber-select"
                              onChange={onChangeVesselScrubber}
                            >
                              {scrubberOptions.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      );
                    }
                    return (
                      <tr key={key}>
                        <th className="text-[11px] font-medium">{item.label}</th>
                        <td>
                          <input
                            value={vessel[item.name] ?? (item.type === "number" ? 0 : "")}
                            type={item.type}
                            onKeyDown={handleKeyDown}
                            name={item.name}
                            onChange={onChangeHandler}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
              className="vessel-consumption-column sm:pl-1 pr-0 py-0 mt-1 sm:mt-0"
            >
              <Grid container>
                <Grid item xs={12}>
                  <div className="text-[11px] font-medium text-[#0f3459] bg-[#e8f0f8] px-1.5 py-0.5 border border-[#cbd5e1] border-b-0 rounded-t-[2px] leading-tight">
                    Ballast Sea Consumptions
                  </div>
                  <table className="vessel-details-tables vessel-consumption-table w-full mb-1">
                    <thead>
                      <tr>
                        <th className="consumption-checkbox-column"></th>
                        <th>Speed*</th>
                        <th>Main</th>
                        <th>ECA</th>
                        <th>MGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselBalComb1Selected"
                            checked={vesselBalComb1Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${vesselBalComb1Selected && checkBallastError(vesselBalSpd1, vesselBalSpd2, vesselBalSpd3, vesselBalSpd4) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselBalSpd1"
                              value={vesselBalSpd1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb1Selected && checkBallastError(vesselBalConsmHS1, vesselBalConsmHS2, vesselBalConsmHS3, vesselBalConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmHS1"
                              value={vesselBalConsmHS1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb1Selected && checkBallastError(vesselBalConsmLS1, vesselBalConsmLS2, vesselBalConsmLS3, vesselBalConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmLS1"
                              value={vesselBalConsmLS1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmMGO1"
                              value={vesselBalConsmMGO1 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 2 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselBalComb2Selected"
                            checked={vesselBalComb2Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb2Selected && checkBallastError(vesselBalSpd1, vesselBalSpd2, vesselBalSpd3, vesselBalSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalSpd2"
                              value={vesselBalSpd2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb2Selected && checkBallastError(vesselBalConsmHS1, vesselBalConsmHS2, vesselBalConsmHS3, vesselBalConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmHS2"
                              value={vesselBalConsmHS2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb2Selected && checkBallastError(vesselBalConsmLS1, vesselBalConsmLS2, vesselBalConsmLS3, vesselBalConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmLS2"
                              value={vesselBalConsmLS2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmMGO2"
                              value={vesselBalConsmMGO2 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 3 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselBalComb3Selected"
                            checked={vesselBalComb3Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb3Selected && checkBallastError(vesselBalSpd1, vesselBalSpd2, vesselBalSpd3, vesselBalSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalSpd3"
                              value={vesselBalSpd3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb3Selected && checkBallastError(vesselBalConsmHS1, vesselBalConsmHS2, vesselBalConsmHS3, vesselBalConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmHS3"
                              value={vesselBalConsmHS3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb3Selected && checkBallastError(vesselBalConsmLS1, vesselBalConsmLS2, vesselBalConsmLS3, vesselBalConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmLS3"
                              value={vesselBalConsmLS3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmMGO3"
                              value={vesselBalConsmMGO3 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 4 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselBalComb4Selected"
                            checked={vesselBalComb4Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb4Selected && checkBallastError(vesselBalSpd1, vesselBalSpd2, vesselBalSpd3, vesselBalSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalSpd4"
                              value={vesselBalSpd4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb4Selected && checkBallastError(vesselBalConsmHS1, vesselBalConsmHS2, vesselBalConsmHS3, vesselBalConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmHS4"
                              value={vesselBalConsmHS4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselBalComb4Selected && checkBallastError(vesselBalConsmLS1, vesselBalConsmLS2, vesselBalConsmLS3, vesselBalConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmLS4"
                              value={vesselBalConsmLS4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Ballast LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselBalConsmMGO4"
                              value={vesselBalConsmMGO4 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>

                {/* Laden Sea Consumptions */}
                <Grid item xs={12}>
                  <div className="text-[11px] font-medium text-[#0f3459] bg-[#e8f0f8] px-1.5 py-0.5 mt-1 border border-[#cbd5e1] border-b-0 rounded-t-[2px] leading-tight">
                    Laden Sea Consumptions
                  </div>
                  <table className="vessel-details-tables vessel-consumption-table w-full mb-1">
                    <thead>
                      <tr>
                        <th className="consumption-checkbox-column"></th>
                        <th>Speed*</th>
                        <th>Main</th>
                        <th>ECA</th>
                        <th>MGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Comb 1 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselLadComb1Selected"
                            checked={vesselLadComb1Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb1Selected && checkLadenError(vesselLdnSpd1, vesselLdnSpd2, vesselLdnSpd3, vesselLdnSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnSpd1"
                              value={vesselLdnSpd1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb1Selected && checkLadenError(vesselLdnConsmHS1, vesselLdnConsmHS2, vesselLdnConsmHS3, vesselLdnConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmHS1"
                              value={vesselLdnConsmHS1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb1Selected && checkLadenError(vesselLdnConsmLS1, vesselLdnConsmLS2, vesselLdnConsmLS3, vesselLdnConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmLS1"
                              value={vesselLdnConsmLS1 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmMGO1"
                              value={vesselLdnConsmMGO1 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 2 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselLadComb2Selected"
                            checked={vesselLadComb2Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb2Selected && checkLadenError(vesselLdnSpd1, vesselLdnSpd2, vesselLdnSpd3, vesselLdnSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnSpd2"
                              value={vesselLdnSpd2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb2Selected && checkLadenError(vesselLdnConsmHS1, vesselLdnConsmHS2, vesselLdnConsmHS3, vesselLdnConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmHS2"
                              value={vesselLdnConsmHS2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb2Selected && checkLadenError(vesselLdnConsmLS1, vesselLdnConsmLS2, vesselLdnConsmLS3, vesselLdnConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmLS2"
                              value={vesselLdnConsmLS2 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmMGO2"
                              value={vesselLdnConsmMGO2 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 3 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselLadComb3Selected"
                            checked={vesselLadComb3Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb3Selected && checkLadenError(vesselLdnSpd1, vesselLdnSpd2, vesselLdnSpd3, vesselLdnSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnSpd3"
                              value={vesselLdnSpd3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb3Selected && checkLadenError(vesselLdnConsmHS1, vesselLdnConsmHS2, vesselLdnConsmHS3, vesselLdnConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmHS3"
                              value={vesselLdnConsmHS3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb3Selected && checkLadenError(vesselLdnConsmLS1, vesselLdnConsmLS2, vesselLdnConsmLS3, vesselLdnConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmLS3"
                              value={vesselLdnConsmLS3 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              name="vesselLdnConsmMGO3"
                              value={vesselLdnConsmMGO3 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Comb 4 */}
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            className="input-type-checkbox"
                            name="vesselLadComb4Selected"
                            checked={vesselLadComb4Selected || false}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb4Selected && checkLadenError(vesselLdnSpd1, vesselLdnSpd2, vesselLdnSpd3, vesselLdnSpd4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselLdnSpd4"
                              value={vesselLdnSpd4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden Speed-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb4Selected && checkLadenError(vesselLdnConsmHS1, vesselLdnConsmHS2, vesselLdnConsmHS3, vesselLdnConsmHS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselLdnConsmHS4"
                              value={vesselLdnConsmHS4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden HS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className={`custom-input-outer ${(vesselLadComb4Selected && checkLadenError(vesselLdnConsmLS1, vesselLdnConsmLS2, vesselLdnConsmLS3, vesselLdnConsmLS4)) && "req-error"}`}>
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselLdnConsmLS4"
                              value={vesselLdnConsmLS4 || ""}
                              onChange={onChangeHandler}
                            />
                            <div className="error-notification">
                              <CustomTooltip text="Laden LS-Consumption should be non-zero." position="top">
                                <img src={errorIcon} alt="Show validation error" tabIndex={0} />
                              </CustomTooltip>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="custom-input-outer">
                            <input
                              type="number"
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              name="vesselLdnConsmMGO4"
                              value={vesselLdnConsmMGO4 || ""}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>

                {/* Port Consumptions */}
                <Grid item xs={12}>
                  <div className="text-[11px] font-medium text-[#0f3459] bg-[#e8f0f8] px-1.5 py-0.5 mt-1 border border-[#cbd5e1] border-b-0 rounded-t-[2px] leading-tight">
                    Port Consumptions
                  </div>
                  <table className="vessel-details-tables w-full" style={{ tableLayout: "fixed" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "31%" }}></th>
                        <th style={{ width: "23%" }}>Main</th>
                        <th style={{ width: "23%" }}>ECA</th>
                        <th style={{ width: "23%" }}>MGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Idle</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPIdleConsmHS"
                            value={vesselPIdleConsmHS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPIdleConsmLS"
                            value={vesselPIdleConsmLS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPIdleConsmMGO"
                            value={vesselPIdleConsmMGO || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Loading</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPLdgConsmHS"
                            value={vesselPLdgConsmHS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPLdgConsmLS"
                            value={vesselPLdgConsmLS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPLdgConsmMGO"
                            value={vesselPLdgConsmMGO || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Disch</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPDischConsmHS"
                            value={vesselPDischConsmHS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPDischConsmLS"
                            value={vesselPDischConsmLS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselPDischConsmMGO"
                            value={vesselPDischConsmMGO || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Extra</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselVExtraConsmHS"
                            value={vesselVExtraConsmHS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselVExtraConsmLS"
                            value={vesselVExtraConsmLS || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            name="vesselVExtraConsmMGO"
                            value={vesselVExtraConsmMGO || ""}
                            onChange={onChangeHandler}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="text-[10px] text-slate-400 italic text-center mt-0.5">
                    * We determine the best speed pick and utilize it for the calculation.
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid >
      <CustomAddModal
        open={open}
        saveLabel={"Add"}
        title="Create New Vessel"
        footerExtra={
          <button
            type="button"
            className="flex items-center gap-1.5 px-2.5 h-[28px] text-[11px] font-medium text-white bg-[#313C4C] border border-[#313C4C] rounded-none shadow-2xs cursor-pointer hover:bg-[#0c2f50] transition-colors"
            onClick={() => setAiOpen(true)}
          >
            <LuSparkles size={14} /> Create with AI
          </button>
        }
        maxWidth="xl"
        handleClose={onCloseModal}
        onSubmitConfirm={onSubmitConfirm}
      >
        <AddNewVessel
          vessel={newVessel}
          onAiFill={(patch) => setNewVessel((prev) => ({ ...prev, ...patch }))}
          aiOpen={aiOpen}
          setAiOpen={setAiOpen}
          onChangeHandler={onChangeHandlerForNew}
          addNewSplitHire={addNewSplitHire}
          onChangeBunkerPriceOverridden={onChangeBunkerPriceOverridden}
          onChangeSplitHire={onChangeSplitHire}
          delayPortSearch={delayPortSearch}
          portLoading={portLoading}
          onChangePort={onChangePort}
          savePortList={savePortList}
        />
      </CustomAddModal>
    </Grid >
  );
}

export default memo(CalculatorVesselDetails);
